<template lang="pug">
#layer
  //- 图层
  .layerpop(v-show='!layerDetailBoolean')
    ul
      li(@click='showAllLayers')
        span 图层列表
        van-icon.layerright(size='14' name='arrow')
      li(v-for='(item,index) in layerList' :class='{ activelayer: index === activeIndex && selectBoolean }' @click='changeLayer(index)' :key='index')
        span {{item}}
        van-image(v-if='activeIndex === index && selectBoolean ' :src='hookImg')
  //- 图层详情
  .layerDetail(v-show='layerDetailBoolean')
    .header
      span(@click='cancelDetail') 取消
      span 图层列表
      van-icon(name='cross' size='16' color='#fff' @click='closeAll')
    .layerDetailbody
      ul
        li(v-for='(item,index) in layerData' :key='index' @click='layersFunc(item)')
          van-image.showeye(:src='showeye' v-show='item.isVisible')
          van-image.showeye(:src='hideeye' v-show='!item.isVisible')
          span {{item.name}}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";

export default {
  data () {
    return {
      layerList: ["关闭当前图层", "关闭其他图层", "全部展示"],
      activeIndex: '',
      hookImg: require("@/CommonDP/mongeView/appView/images/hook.png"),
      layerDetailBoolean: false,
      layerData: [],
      showeye: require("@/CommonDP/mongeView/appView/images/showeye.png"),
      hideeye: require("@/CommonDP/mongeView/appView/images/hideeye.png"),
      selectBoolean: false
    };
  },
  computed: {
    closeLayer() {
      return mongeApp.map.closeLayer;
    }
  },
  watch: {
    closeLayer() {
      this.selectBoolean = false;
    }
  },
  methods: {
    showAllLayers() {
      this.activeIndex = "";
      this.getTableData();
      this.layerDetailBoolean = true;
    },
    async changeLayer(index) {
      this.activeIndex = index;
      if (index === 0) { // 关闭当前图层
        this.selectBoolean = !this.selectBoolean;
        if (this.selectBoolean) mongeApiMlib.mapAddSelectionEvent();
      } else if (index === 1) { // 关闭其他图层
        this.selectBoolean = true;
        await mongeApiMlib.mapOtherSelectionEvent();
      } else if (index === 2) { // 全部展示
        this.selectBoolean = true;
        mongeApiMlib.setAllVisible(true);
        await this.$nextTick();
        this.activeIndex = "";
        this.selectBoolean = false;
      }
    },
    layersFunc(item) {
      mongeApiMlib.setVisibleById(item.id, !item.isVisible);
      this.getTableData();
    },
    async getTableData() {
      this.layerData = await mongeApiMlib.mapLayers();
    },
    cancelDetail() {
      this.layerDetailBoolean = false;
    },
    closeAll() {
      this.layerDetailBoolean = false;
    }
  }

};
</script>

<style lang="scss" scoped>
.layerpop {
  position: absolute;
  width: calc(100% - 24px);
  margin-left: 12px;
  height: 210px;
  background: rgba(0, 0, 0, 0.68);
  bottom: 58px;
  ul{
    width: 100%;
    height: 100%;
    li{
      padding: 0 15px;
      width: 100%;
      height: 50px;
      color: #ffffff;
      .layerright {
        float: right;
        line-height: 50px;
        color: #ffffff;
      }
      span{
        font-size: 14px;
        line-height: 50px;
      }
      .van-image{
        width: 20px;
        height: 16px;
        margin-top: 17px;
        float: right;
      }
    }
    .activelayer{
      background: rgba(85, 132, 255, 0.1) !important;
      color: #1278FF !important;
    }
  }
}
.layerDetail{
  position: absolute;
  width: calc(100% - 24px);
  margin-left: 12px;
  height: 250px;
  background: rgba(0, 0, 0, 0.68);
  bottom: 58px;
  border-radius: 5px;
  .header{
    width: 100%;
    height: 48px;
    padding: 0 10px;
    color: #fff;
    border-bottom: 1px solid #262D3A;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    span{
      font-size: 16px;
    }
  }
  .layerDetailbody{
    width: 100%;
    height: calc(100% - 48px);
  }
  ul{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    li{
      width: 100%;
      height: 32px;
      color: #ffffff;
      padding: 0 10px;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      align-items: center;
      // justify-content: center;
      .van-image{
        width: 16px;
        height: 16px;
        margin-right:10px;
      }
    }
    li:hover{
      background: rgba(111, 111, 111, 0.2);
    }
  }
}
</style>
